export interface AuthResponse {
    user: User;
    authToken: string;
    refreshToken: string;
}

export interface ListResponse<T> {
    items: T[];
    totalCount: number;
    page: number;
    pageSize: number;
    pageCount: number;
}

export interface SimpleListResponse<T> {
    items: T[];
}

export interface Structure {
    [key: string]: string[];
}

export enum Roles {
    admin = 'administrateur',
    manager = 'gestionnaire',
    user = 'consultation',
    signup = 'signup',
}

export enum MimeTypes {
    avi = 'video/x-msvideo',
    doc = 'application/msword',
    docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    jpg = 'image/jpeg',
    jpeg = 'image/jpeg',
    mov = 'video/quicktime',
    mp4 = 'video/mp4',
    pdf = 'application/pdf',
    png = 'image/png',
    ppt = 'application/vnd.ms-powerpoint',
    pptx = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    xls = 'application/vdn.ms-excel',
    xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export const getReadableMimeType = (type: MimeTypes) => {
    switch (type) {
        case MimeTypes.avi:
            return 'video';
        case MimeTypes.doc:
            return 'word';
        case MimeTypes.docx:
            return 'word';
        case MimeTypes.jpg:
            return 'image';
        case MimeTypes.jpeg:
            return 'image';
        case MimeTypes.mov:
            return 'video';
        case MimeTypes.mp4:
            return 'video';
        case MimeTypes.pdf:
            return 'pdf';
        case MimeTypes.png:
            return 'image';
        case MimeTypes.ppt:
            return 'ppt';
        case MimeTypes.pptx:
            return 'ppt';
        case MimeTypes.xls:
            return 'excel';
        case MimeTypes.xlsx:
            return 'excel';
        default:
            return 'document';
    }
};

export enum SectionType {
    folder = 'folder',
    trash = 'trash',
}

export interface User {
    id: string;
    firstName: string;
    lastName: string;
    role: Roles;
    position: string;
    email: string;
    password: string;
    oldPasswords?: string[];
    phone?: string;
    createdAt: Date;
}

export interface Section {
    id: string;
    parent: Section;
    children: [Section];
    name: string;
    short: string;
    picto: string;
    type: SectionType;
}

export interface Document {
    id: string;
    name: string;
    description?: string;
    fileName: string;
    url: string;
    type: MimeTypes;
    file?: string;
    section: Section;
    year: string;
    createdAt: Date;
    createdBy: User;
    updatedAt?: Date;
    updatedBy?: User;
}
